import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../config";
const Connectclts = () => {
  const [phone, setPhone] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [client, setClient] = useState(null);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" ou "error"
  const [showModal, setShowModal] = useState(false); // 🔹 affiche ou cache la modal
  const [fadeOut, setFadeOut] = useState(false); // ✅ pour l’animation de disparition
    const navigate = useNavigate();

  // Formater le numéro
  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length === 0) return "";
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
      6,
      10
    )}`;
  };
  const [formData, setFormData] = useState({
    idclt: "",
    idserv: "",
    histnbre: "1",
    iduser: "",
    histstatut: 0, // exemple de statut par défaut
  });
  const onPhoneChange = (e) => {
    setPhone(formatPhoneNumber(e.target.value));
    // setPhone(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (phone.length !== 14) {
      setMessage("The phone number must contain exactly 14 characters !");
      setMessageType("success");
      setShowModal(true);
      setFadeOut(false);
      setTimeout(() => setFadeOut(true), 3000);
      setTimeout(() => {
  setShowModal(false);
  console.log("redirection vers home");
  navigate("/clogin");        // ← redirection vers Home
}, 3000);
      return; // stoppe la soumission
    }
    setClient(null);
    const encodedPhone = encodeURIComponent(phone);
    try {
      const res = await fetch(`${API_URL}/clientel/${encodedPhone}`);
      const data = await res.json();
      if (data.nomclt === "NONECLT") {
        setClient(null);
      } else {
        setClient(data);
      }
    } catch (err) {
      console.error("Erreur chargement client:", err);
      setClient(null);
    }

    setSubmitted(true);
  };

  const handleReset = () => {
    setSubmitted(false);
    setClient(null);
    setPhone("");
  };

  const [client2, setClient2] = useState({
    codclt: "",
    nomclt: "",
    prenomclt: "",
    telclt: "",
    emailclt: "",
    checkclt: 0,
    servclt: 0,
    suppclt: 0,
    iduser: 1, // exemple d’utilisateur connecté
  });

  const handleChangenwl = (e) => {
    setClient2({
      ...client2,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    client2.telclt = phone;

    try {
      const res = await axios.post(`${API_URL}/enregistrer_client/`, client2);

      setMessage("...Ckeck in succesfuly...");
      setMessageType("success");
      setShowModal(true);
      setFadeOut(false);

      // Réinitialisation
      setClient2({
        codclt: "",
        nomclt: "",
        prenomclt: "",
        telclt: "",
        emailclt: "",
        checkclt: 0,
        servclt: 0,
        suppclt: 0,
        iduser: 1,
      });

      // 🕒 Disparition avec animation
      setTimeout(() => setFadeOut(true), 2000);
       setTimeout(() => {
  setShowModal(false);
  navigate("/clogin");        // ← redirection vers Home
}, 3000);
    } catch (err) {
      console.error("Erreur:", err.response?.data || err.message);
      setMessage("Erreur lors de l’enregistrement du client !");
      setMessageType("error");
      setShowModal(true);
      setFadeOut(false);

      setTimeout(() => setFadeOut(true), 4000);
     setTimeout(() => {
  setShowModal(false);
  navigate("/clogin");        // ← redirection vers Home
}, 4000);
    }
    setSubmitted(false);
    setPhone("");
  };

  //ENREGISTREMENT DES HISTCLIENTS..............................................................................

  const handleSavehclt = async () => {
    if (!client || !client.idclt) {
      alert("Impossible d'enregistrer l'historique : client non défini !");
      return;
    }

    // Préparer le payload pour Django
    const payload = {
      idclt: client.idclt, // obligatoire
      idserv: formData.idserv || null,
      histnbre: parseInt(formData.histnbre) || 1, // obligatoire
      iduser: formData.iduser || null, // par défaut
      histstatut: formData.histstatut || 0,
      // histdate et histtime sont définis côté serveur
    };

    try {
      const res = await axios.post(`${API_URL}/add_hist_client/`, payload);

      setMessage(" Check-in successfully ");
      setMessageType("success");
      setShowModal(true);
      setFadeOut(false);

      // Réinitialiser le formulaire
      setFormData({
        idclt: "",
        idserv: "",
        histnbre: "1",
        iduser: "",
        histstatut: 0,
      });

      // Disparition automatique de la modale
      setTimeout(() => setFadeOut(true), 2000);
       setTimeout(() => {
  setShowModal(false);
  navigate("/clogin");        // ← redirection vers Home
}, 3000);
    } catch (err) {
      console.error("Erreur:", err.response?.data || err.message);
      setMessage("Client deja en service.");
      setMessageType("error");
      setShowModal(true);
      setFadeOut(false);

      setTimeout(() => setFadeOut(true), 2000);
      setTimeout(() => setShowModal(false), 3000);
    }
    setSubmitted(false);
    setPhone("");
  };

  return (
    <div className="container-fluid" style={styles.pageBackground}>
      {/* Bandeau défilant */}
      <div style={styles.marqueeContainer}>
        <marquee behavior="scroll" direction="left" scrollamount="6">
          <span style={styles.marqueeText}>
            WELCOME TO NADINE'S HAIR BRAIDING &nbsp; | &nbsp; Tel: (202)
            706-2506 &nbsp; | &nbsp; Address: 4501 Mitchellville Road, Bowie, MD
            20716
          </span>
        </marquee>
      </div>

      <div id="corps" className="text-center mt-5">
        {/* 🔹 Fenêtre modale avec animation */}
        {showModal && (
          <div
            style={{
              ...styles.modalOverlayFull,
              opacity: fadeOut ? 0 : 1,
              transition: "opacity 0.8s ease",
            }}
          >
            <div
              style={{
                ...styles.modalCentered,
                border:
                  messageType === "success"
                    ? "2px solid #c3e6cb"
                    : "2px solid #f5c6cb",
                backgroundColor:
                  messageType === "success" ? "#d4edda" : "#f8d7da",
                color: messageType === "success" ? "#155724" : "#721c24",
                boxShadow: "0 6px 20px rgba(0, 0, 0, 0.25)",
              }}
            >
              <h3 style={{ fontWeight: "bold", margin: 0 }}>{message}</h3>
            </div>
          </div>
        )}
        {!submitted ? (
          <>
            <div className="row justify-content-center">
              {" "}
              <div className="col-md-5 text-center">
                {" "}
                <h4 style={styles.warningText}>
                  {" "}
                  A $5 fee will be added to transactions made through Mobile
                  App, Credit Card & Debit Card
                </h4>
              </div>
            </div>
            {/* Formulaire principal */}
            <div className="row justify-content-center mt-1">
              <div className="col-md-4 col-lg-4">
                <div className="p-4 p-md-5" style={styles.loginWrap}>
                  <div
                    className="d-flex align-items-center justify-content-center mb-3"
                    style={styles.icon}
                  >
                    <img
                      src={require("../../assets/images/logo_fenasu.png")}
                      alt="logo"
                      style={{ width: "200px" }}
                    />
                  </div>

                  <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3">
                      <input
                        type="text"
                        className="form-control form-control-lg rounded"
                        placeholder="Enter your phone number"
                        required
                        value={phone}
                        onChange={onPhoneChange}
                        autoFocus
                      />
                    </div>

                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg w-100 fw-bold"
                      >
                        <h5>.....Search your phone.....</h5>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-md-5 text-center">
                {" "}
                <h4 style={styles.warningText}>
                  {" "}
                  A $5 fee will be added to transactions made through Mobile
                  App, Credit Card & Debit Card{" "}
                </h4>{" "}
              </div>{" "}
            </div>
          </>
        ) : (
          <>
            {client ? (
              <div
                className="col-md-5 mx-auto my-5 p-5 shadow-lg rounded-5 bg-light text-dark"
                style={{
                  borderTop: "6px solid #0d6efd",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 20px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 5px 15px rgba(0,0,0,0.1)";
                }}
              >
                <h2
                  className="text-center text-primary fw-bold mb-5"
                  style={{ fontSize: "2rem" }}
                >
                  ✅ CLIENT INFORMATION FOUND ✅
                </h2>

                <div className="mb-5">
                  <p
                    className="mb-3"
                    style={{ fontSize: "2.1rem", textAlign: "left" }}
                  >
                    <strong className="text-secondary">👤 Names:</strong>{" "}
                    <span className="fw-semibold text-dark">
                      {client.nomclt} {client.prenomclt}
                    </span>
                  </p>
                  <p
                    className="mb-3"
                    style={{ fontSize: "2.1rem", textAlign: "left" }}
                  >
                    <strong className="text-secondary">📞 Phone:</strong>{" "}
                    <span className="fw-semibold text-dark">
                      {client.telclt}
                    </span>
                  </p>
                  <p
                    className="mb-0"
                    style={{ fontSize: "2.1rem", textAlign: "left" }}
                  >
                    <strong className="text-secondary">✉️ Email:</strong>{" "}
                    <span className="fw-semibold text-dark">
                      {client.emailclt}
                    </span>
                  </p>
                </div>

                <div
                  className="d-flex justify-content-center align-items-center gap-5 mt-5"
                  style={{ flexWrap: "wrap" }}
                >
                  <button
                    className="btn"
                    style={{
                      fontSize: "1.4rem",
                      minWidth: "200px",
                      borderRadius: "12px",
                      background: "linear-gradient(135deg, #0d6efd, #0954c6)",
                      color: "white",
                      border: "none",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                      transition: "all 0.25s ease-in-out",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.07)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 18px rgba(0, 0, 0, 0.35)";
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #d1e495ff, #adf775ff)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(0, 0, 0, 0.3)";
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #0d6efd, #0954c6)";
                    }}
                    onMouseDown={(e) => {
                      e.currentTarget.style.transform = "scale(0.96)";
                    }}
                    onMouseUp={(e) => {
                      e.currentTarget.style.transform = "scale(1.07)";
                    }}
                    onClick={() => handleSavehclt()}
                  >
                    🔁 Check In
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button
                    className="btn"
                    style={{
                      fontSize: "1.4rem",
                      minWidth: "200px",
                      borderRadius: "12px",
                      background: "linear-gradient(135deg, #dc3545, #b02a37)",
                      color: "white",
                      border: "none",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
                      transition: "all 0.25s ease-in-out",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.07)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 18px rgba(0, 0, 0, 0.35)";
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #e35d6a, #d63342)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(0, 0, 0, 0.25)";
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #dc3545, #b02a37)";
                    }}
                    onMouseDown={(e) => {
                      e.currentTarget.style.transform = "scale(0.96)";
                    }}
                    onMouseUp={(e) => {
                      e.currentTarget.style.transform = "scale(1.07)";
                    }}
                    onClick={() => handleReset()}
                  >
                    ❌ Cancel
                  </button>
                </div>
              </div>
            ) : (
              <div
                className="col-md-4 mx-auto my-5 p-5 bg-light rounded-4 shadow-lg"
                style={{
                  borderTop: "6px solid #99c7f3ff",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 25px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 5px 15px rgba(0,0,0,0.1)";
                }}
              >
                <h3 className="text-center text-danger fw-bold mb-4">
                  ⚠️ Please Fill Your Information ⚠️
                </h3>

                <form onSubmit={handleSave} id="lg-form2" name="fnewathlete">
                  {/* Champ Nom */}
                  <div className="form-group mb-4">
                    <label
                      htmlFor="nomclt"
                      className="fw-semibold text-secondary fs-5 mb-2"
                      style={{
                        fontSize: "1.9rem",
                        textAlign: "left",
                      }}
                    >
                      👤 Full Name
                    </label>
                    <input
                      type="text"
                      name="nomclt"
                      className="form-control form-control-lg rounded-3 border-2"
                      required
                      value={client2.nomclt}
                      onChange={handleChangenwl}
                      placeholder="Enter your full name"
                      style={{ fontSize: "1.2rem" }}
                    />
                  </div>

                  {/* Champ Téléphone */}
                  <div className="form-group mb-4">
                    <label
                      htmlFor="phone"
                      className="fw-semibold text-secondary fs-5 mb-2"
                      style={{
                        fontSize: "1.9rem",
                        textAlign: "left",
                      }}
                    >
                      📞 Phone Number
                    </label>
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      className="form-control form-control-lg rounded-3 border-2"
                      required
                      disabled
                      value={phone}
                      onChange={onPhoneChange}
                      placeholder="Enter your phone number"
                      style={{ fontSize: "1.2rem" }}
                    />
                  </div>

                  {/* Champ Email */}
                  <div className="form-group mb-5">
                    <label
                      htmlFor="email"
                      className="fw-semibold text-secondary fs-5 mb-2"
                      style={{
                        fontSize: "1.9rem",
                        textAlign: "left",
                      }}
                    >
                      ✉️ Email Address
                    </label>
                    <input
                      type="email"
                      name="emailclt"
                      value={client2.emailclt}
                      className="form-control form-control-lg rounded-3 border-2"
                      onChange={handleChangenwl}
                      placeholder="Enter your email"
                      style={{ fontSize: "1.2rem" }}
                    />
                  </div>

                  {/* Bouton */}
                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn"
                      style={{
                        fontSize: "1.4rem",
                        minWidth: "200px",
                        borderRadius: "12px",
                        background: "linear-gradient(135deg, #0d6efd, #0954c6)",
                        color: "white",
                        border: "none",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                        transition: "all 0.25s ease-in-out",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.07)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 18px rgba(0, 0, 0, 0.35)";
                        e.currentTarget.style.background =
                          "linear-gradient(135deg, #9afd73ff, #aee7b3ff)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 10px rgba(0, 0, 0, 0.3)";
                        e.currentTarget.style.background =
                          "linear-gradient(135deg, #0d6efd, #0954c6)";
                      }}
                      onMouseDown={(e) => {
                        e.currentTarget.style.transform = "scale(0.96)";
                      }}
                      onMouseUp={(e) => {
                        e.currentTarget.style.transform = "scale(1.07)";
                      }}
                    >
                      🔁 Check In
                    </button>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button
                      className="btn"
                      style={{
                        fontSize: "1.4rem",
                        minWidth: "200px",
                        borderRadius: "12px",
                        background: "linear-gradient(135deg, #dc3545, #b02a37)",
                        color: "white",
                        border: "none",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
                        transition: "all 0.25s ease-in-out",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.07)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 18px rgba(0, 0, 0, 0.35)";
                        e.currentTarget.style.background =
                          "linear-gradient(135deg, #e35d6a, #d63342)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 10px rgba(0, 0, 0, 0.25)";
                        e.currentTarget.style.background =
                          "linear-gradient(135deg, #dc3545, #b02a37)";
                      }}
                      onMouseDown={(e) => {
                        e.currentTarget.style.transform = "scale(0.96)";
                      }}
                      onMouseUp={(e) => {
                        e.currentTarget.style.transform = "scale(1.07)";
                      }}
                      onClick={() => handleReset()}
                    >
                      ❌ Cancel
                    </button>
                  </div>
                </form>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

// 🎨 Styles
const styles = {
  pageBackground: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f9f9f9 0%, #e6ecff 100%)",
    paddingBottom: "40px",
  },
  marqueeContainer: {
    background: "linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)",
    padding: "10px 0",
    borderBottom: "4px solid #fff",
    borderTop: "4px solid #fff",
  },
  marqueeText: {
    color: "white",
    fontWeight: "bold",
    fontSize: "1.3rem",
    letterSpacing: "1px",
  },
  loginWrap: {
    background: "#fff",
    borderRadius: 11,
    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
  },
  icon: {
    marginBottom: 10,
  },
  warningText: {
    color: "#d9534f",
    fontWeight: "bold",
    backgroundColor: "#fff5f5",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #f5c6cb",
  },
  resultBox: {
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  },
  // Dans ton objet styles
  modalOverlayFull: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 3000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(3px)",
    transition: "opacity 0.8s ease",
  },

  modalCentered: {
    padding: "30px 60px",
    borderRadius: "14px",
    textAlign: "center",
    fontSize: "1.5rem",
    background: "#fff",
    maxWidth: "500px",
    width: "80%",
    animation: "scaleUp 0.5s ease forwards", // ✅ animation ajoutée
  },
};

export default Connectclts;
